import React from "react";
import { Handshake, Target, Award, Users } from "lucide-react";

const TEAM_IMG = "https://images.unsplash.com/photo-1759272548449-7b689a81c8fb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function About() {
  return (
    <div>
      <section className="bg-[#0B3D6E] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="font-label text-xs text-[#2E7BC7]">About Apex</div>
            <h1 className="mt-3 font-display font-black text-4xl md:text-6xl">Reliable. Transparent. Accountable.</h1>
            <p className="mt-5 text-slate-300 max-w-lg">Our mission is to deliver reliable, transparent, and cost-effective transportation solutions while building long-term partnerships with the customers and carriers who make freight move.</p>
          </div>
          <img src={TEAM_IMG} alt="Apex operations team" className="rounded-lg w-full h-[420px] object-cover" />
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-4 gap-6">
          {[
            { icon: Target, t: "Mission", d: "Reliable, transparent, cost-effective transportation — every load, every day." },
            { icon: Handshake, t: "Partnership", d: "We measure success by the length of our customer and carrier relationships." },
            { icon: Award, t: "Excellence", d: "98.6% on-time delivery, 24/7 operations, obsessive follow-through." },
            { icon: Users, t: "People-first", d: "Real dispatchers. Real drivers. Real accountability — no black boxes." },
          ].map(({ icon: I, t, d }) => (
            <div key={t} className="border border-gray-200 rounded-lg p-7">
              <I className="h-6 w-6 text-[#2E7BC7]" />
              <div className="mt-4 font-display font-bold text-xl text-[#0B3D6E]">{t}</div>
              <p className="mt-2 text-sm text-slate-600">{d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="py-20 bg-gray-50" data-testid="founder-section">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-10 items-start">
          <div>
            <div className="font-label text-xs text-[#2E7BC7]">Founder & Vision</div>
            <h2 className="mt-3 font-display font-black text-3xl md:text-4xl text-[#0B3D6E] leading-tight">Shardul Guleria</h2>
            <div className="mt-2 text-sm text-slate-600">Founder, Apex Supply Chain Solutions</div>
            <div className="mt-6 h-1 w-16 bg-[#2E7BC7]" />
          </div>
          <div className="md:col-span-2 space-y-5 text-slate-700 leading-relaxed">
            <p className="text-lg font-display text-[#0B3D6E]">"I founded Apex with a clear vision: to build a logistics company recognized for reliability, integrity, and exceptional customer service."</p>
            <p>By combining industry expertise with innovative technology and a commitment to operational excellence, our mission is to deliver seamless freight solutions and become a trusted transportation partner for businesses across North America.</p>
            <div className="pt-2 font-label text-xs text-slate-500">— Shardul Guleria, Founder</div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="font-label text-xs text-[#2E7BC7]">Our story</div>
          <h2 className="mt-3 font-display font-black text-3xl md:text-5xl text-[#0B3D6E]">Built by operators. For operators.</h2>
          <div className="mt-6 space-y-5 text-slate-700 leading-relaxed">
            <p>Apex Supply Chain Solutions was founded on a simple belief: freight isn't a commodity, it's a commitment. Every load carries a promise — a customer waiting, a store shelf to stock, a plant that can't afford to stop.</p>
            <p>Today, we combine a nationally vetted carrier network of 12,500+ partners with a modern, API-first technology stack. Shippers see their freight in real time. Carriers get paid quickly, transparently, and fairly. And our operations team is available 24/7 — because supply chains never sleep.</p>
            <p>From coast to coast and across three national borders, Apex moves the loads that build businesses.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
